interface ClearFilterButtonProps {
  onClear: () => void;
}

export default function ClearFilterButton({ onClear }: ClearFilterButtonProps) {
  return (
    <button
      onClick={onClear}
      className="flex items-center gap-1 px-3 py-2 bg-gray-100 rounded-lg text-sm text-gray-700 hover:bg-gray-100 transition"
    >
      Clear
    </button>
  );
}
